module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'k3ah2kwu',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
